// extracted by mini-css-extract-plugin
export default {"page":"batch-print_page__4oax-","printElement":"batch-print_printElement__i5uJe","hideElement":"batch-print_hideElement__eR76D","noBorder":"batch-print_noBorder__8A6Ba"};